import styled from 'styled-components';

export const Container = styled.div`
  .anchors {
    &__title {
      display: inline-block;
      margin-right: 9px;
    }
  }

  ul {
    display: inline-block;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      position: relative;
      display: inline-block;

      &:not(:last-of-type) {
        padding-right: 8px;
        margin-right: 8px;

        &::after {
          content: '\\e925';
          font-family: icomoon;
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      a {
        cursor: pointer;
      }
    }
  }

  .MuiSkeleton-root {
    display: inline-block;
  }
`;

export default Container;
